import { api } from "./api";

export const counselor = async (data) => {
  return await api.get(`/counselor`, data);
}

export const ResponseData = async (addUrl = '') => {
  let url = `/calling/counselor/followup/list?${addUrl}`
  return await api.get(url)
}